import React from 'react'
import { Alert, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { MUIButton } from 'components/common/MUIButton'

interface Props {
  /** What failed, said to the client. */
  message: string
  /** Without one the alert only explains. */
  onRetry?: () => void
  'data-cy'?: string
}

/**
 * A failed request the flow cannot continue without: says so and offers the retry that fixes it, so
 * the step is never left with a disabled Proceed and nothing to do.
 */
export const PfRetryAlert: React.FC<Props> = ({ message, onRetry, 'data-cy': dataCy }) => {
  const { t } = useTranslation(['purchase_flow_revamp'])
  return (
    <Stack gap={1.2} data-cy={dataCy}>
      <Alert severity="error">{message}</Alert>
      {onRetry &&
        <Stack direction="row">
          <MUIButton size="sm" onClick={onRetry}>
            {t('purchase_flow_revamp:instructions.options_error_retry')}
          </MUIButton>
        </Stack>
      }
    </Stack>
  )
}
